import { defineOnboaring } from '../types';

export default defineOnboaring({
  id: 'recipientConfirmation',
  welcomeStep: {
    defaultImage: {
      url: '/onboarding/recipient-confirmation/welcome.jpg',
      style: {
        objectFit: 'cover',
      },
    },
    title: 'onboarding.recipientConfirmation.welcome.title',
    description: 'onboarding.recipientConfirmation.welcome.description',
  },
  steps: [
    {
      image: {
        fr: {
          url: '/onboarding/recipient-confirmation/fr/step1.png',
        },
      },
      title: 'onboarding.recipientConfirmation.step1.title',
      description: 'onboarding.recipientConfirmation.step1.description',
    },
    {
      image: {
        fr: {
          url: '/onboarding/recipient-confirmation/fr/step2.png',
        },
      },
      title: 'onboarding.recipientConfirmation.step2.title',
      description: 'onboarding.recipientConfirmation.step2.description',
    },
    {
      image: {
        fr: {
          url: '/onboarding/recipient-confirmation/fr/step3.png',
        },
      },
      title: 'onboarding.recipientConfirmation.step3.title',
      description: 'onboarding.recipientConfirmation.step3.description',
    },
    {
      image: {
        fr: {
          url: '/onboarding/recipient-confirmation/fr/step4.png',
        },
      },
      title: 'onboarding.recipientConfirmation.step4.title',
      description: 'onboarding.recipientConfirmation.step4.description',
    },
    {
      image: {
        fr: {
          url: '/onboarding/recipient-confirmation/fr/step5.png',
        },
      },
      title: 'onboarding.recipientConfirmation.step5.title',
      description: 'onboarding.recipientConfirmation.step5.description',
    },
    {
      image: {
        fr: {
          url: '/onboarding/recipient-confirmation/fr/step6.png',
        },
      },
      title: 'onboarding.recipientConfirmation.step6.title',
      description: 'onboarding.recipientConfirmation.step6.description',
    },
    {
      image: {
        fr: {
          url: '/onboarding/recipient-confirmation/fr/step7.png',
        },
      },
      title: 'onboarding.recipientConfirmation.step7.title',
      description: 'onboarding.recipientConfirmation.step7.description',
    },
    {
      image: {
        fr: {
          url: '/onboarding/recipient-confirmation/fr/step8.png',
        },
      },
      title: 'onboarding.recipientConfirmation.step8.title',
      description: 'onboarding.recipientConfirmation.step8.description',
    },
  ],
});
